import useStore from "../hooks/useStore";
import InfoTag from "./dataSchema/InfoTag";
import { StringAttr, ListAttr, ObjectAttr } from "./dataSchema/attrs";
import SubInfoContainer from "./dataSchema/SubInfoContainer";
import XrayToggle from "./widgets/XrayToggle";
import { getValType, isID, getInfoObjId, clearDataState } from "../utils";
import { T } from "../global";
import { useEffect } from "react";
import { cn, getObjName, getDisplayName } from "../utils";
import { highlgihtInfoObj } from "../utils";

function InfoContainer() {
  // console.log(selected);
  // const schema = useStore((state) => state.schema); // data schema
  let data = useStore((state) => state.data); // data
  const setData = useStore((state) => state.setData);
  const pivotObject = useStore((state) => state.pivotObject);
  const infoObjects = useStore((state) => state.unlabeledInfoObjects);
  const xray = useStore((state) => state.xray);
  // const updateData = useStore((state) => state.updateData);

  function syncHighlighting(schema, attr, attrType) {
    if (attrType === T.LIST || attrType === T.DB) {
      const _attr = getObjName(schema[attr][0]);
      const cn = `${_attr}-sframe`;
      try {
        highlgihtInfoObj(cn);
      } catch (e) {}
    } else if (
      attrType === T.VAL &&
      schema[attr] &&
      schema[attr].startsWith("__")
    ) {
      const _attr = getObjName(schema[attr]);
      const cn = `${_attr}-sframe`;
      try {
        highlgihtInfoObj(cn);
      } catch (e) {}
    }
  }

  function clearHighlighting(schema, attr, attrType) {
    if (attrType === T.LIST || attrType === T.DB) {
      const _attr = getObjName(schema[attr][0]);
      const cn = `${_attr}-sframe`;
      try {
        clearDataState(cn);
      } catch (e) {}
    } else if (
      attrType === T.VAL &&
      schema[attr] &&
      schema[attr].startsWith("__")
    ) {
      const _attr = getObjName(schema[attr]);
      const cn = `${_attr}-sframe`;
      try {
        clearDataState(cn);
      } catch (e) {}
    }
  }

  useEffect(() => {
    setData(data);
  }, [data, setData]);

  function recursiveRender(parent, name, schema) {
    // console.log(schema);
    const schemaType = getValType(schema);
    const key = `${parent}-${name}-${JSON.stringify(schema)}`; // ensure unique and consistent keys

    switch (schemaType) {
      case T.VAL:
        // console.log("render val attr:", parent, name, schema);
        if (schema === "string") {
          return <StringAttr key={key} attr={name} data={data[parent]} />;
        } else {
          if (schema.includes("::")) {
            const [dType, fType] = schema.split("::");
            return (
              <div key={key} className="schema-type-item">
                <span className="dType">{dType}</span>
                <span className="fType">{fType}</span>
              </div>
            );
          } else {
            return (
              <div key={key} className="sample-val-item">
                {schema}
              </div>
            );
          }
        }
      case T.LIST:
        if (!isID(name)) {
          // console.log("render list attr", parent, name, schema);
          return (
            <div key={key} className="sample-val-item">
              {schema}
            </div>
          );
          // return <ListAttr attr={name} data={data[parent]} />;
        } else {
          return null;
        }
      case T.OBJ:
        if (parent === null) {
          // console.log("render pivot attr", parent, name, schema);
          const taskStructure = pivotObject === name;
          return (
            <div
              key={key}
              className={cn(
                "structure-frame",
                taskStructure
                  ? "task-structure-frame"
                  : "entity-structure-frame",
                `${name}-sframe`
              )}
            >
              <InfoTag name={name} />
              {Object.keys(schema).map((attr, idx) => {
                if (!isID(attr)) {
                  const attrType = getValType(schema[attr]);
                  return (
                    <div
                      key={`${key}-${attr}-${idx}`}
                      className={cn("info-obj-chip", `info-obj-${attrType}`)}
                    >
                      <span
                        className="data-attr"
                        onMouseEnter={() =>
                          syncHighlighting(schema, attr, attrType)
                        }
                        onMouseLeave={() =>
                          clearHighlighting(schema, attr, attrType)
                        }
                      >
                        <span className="data-attr">{attr}</span>
                        <span className="data-attr data-attr-btn">
                          <span>
                            {attrType === T.LIST || attrType === T.DB
                              ? `[${schema[attr][0]}]`
                              : `${getDisplayName(schema[attr])} `}
                          </span>
                        </span>
                      </span>
                      {recursiveRender(name, attr, schema[attr])}
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>
          );
        } else {
          return (
            <div key={key} className="sub-structure-container">
              <div className="sub-structure-frame">
                {Object.keys(schema).map((attr, idx) => {
                  if (!isID(attr)) {
                    const attrType = getValType(schema[attr]);
                    return (
                      <div
                        key={`${key}-${attr}-${idx}`}
                        className={cn("info-obj-chip", `info-obj-${attrType}`)}
                      >
                        <span
                          className="data-attr"
                          onMouseEnter={() =>
                            syncHighlighting(schema, attr, attrType)
                          }
                          onMouseLeave={() =>
                            clearHighlighting(schema, attr, attrType)
                          }
                        >
                          <span className="data-attr">{attr}</span>
                          <span className="data-attr data-attr-btn">
                            <span>
                              {attrType === T.LIST || attrType === T.DB
                                ? `[${schema[attr][0]}]`
                                : `${getDisplayName(schema[attr])} `}
                            </span>
                          </span>
                        </span>
                        {recursiveRender(name, attr, schema[attr])}
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            </div>
          );
        }
      case T.DB:
        // console.log("render db attr:", parent, name, schema);
        // const D = data[parent];
        // const _newdb = [];
        // try {
        //   D.forEach((d) => {
        //     d[name].forEach((dd) => {
        //       let _dd = { ...dd };
        //       _dd["__parent"] = getInfoObjId(parent, d);
        //       _newdb.push(_dd);
        //     });
        //     data[name] = _newdb;
        //   });
        // } catch (e) {
        //   data[name] = [];
        // }

        // updateData(name, _newdb);

        return (
          <div key={key} className="sub-structure-container">
            <div className="sub-structure-frame">
              {Object.keys(schema[0]).map((attr) => {
                if (!isID(attr)) {
                  const attrType = getValType(schema[0][attr]);
                  return (
                    <div
                      key={`${key}-${attr}`}
                      className={cn("info-obj-chip", `info-obj-${attrType}`)}
                    >
                      <span
                        className="data-attr"
                        onMouseEnter={() =>
                          syncHighlighting(schema, attr, attrType)
                        }
                        onMouseLeave={() =>
                          clearHighlighting(schema, attr, attrType)
                        }
                      >
                        <span className="data-attr">{attr}</span>
                        <span className="data-attr data-attr-btn">
                          <span>
                            {attrType === T.LIST || attrType === T.DB
                              ? `[${schema[0][attr][0]}]`
                              : `${getDisplayName(schema[0][attr])} `}
                          </span>
                        </span>
                      </span>
                      {recursiveRender(name, attr, schema[0][attr])}
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>
          </div>
        );
      default:
        console.log(schemaType);
        return null;
    }
  }

  function renderDataJson() {
    return (
      <div
        className="data-json-container"
        style={{
          zIndex: 999,
        }}
      >
        <h3>Schema JSON</h3>
        <pre
          style={{
            whiteSpace: "pre-wrap",
          }}
        >
          {JSON.stringify(infoObjects, null, 2)}
        </pre>
      </div>
    );
  }

  if (data && pivotObject && data[pivotObject] && infoObjects[pivotObject]) {
    return (
      <div
        className="info-container main-container"
        data-state={xray ? "xray" : "ui"}
      >
        {/* <XrayToggle /> */}
        {/* {recursiveRender(null, pivotObject, infoObjects[pivotObject])} */}
        {Object.keys(infoObjects).map((k) => {
          return recursiveRender(null, k, infoObjects[k]);
        })}
        {renderDataJson()}
      </div>
    );
  } else {
    return (
      <div className="info-container main-container">
        <XrayToggle />
        {renderDataJson()}
      </div>
    );
  }
}

export default InfoContainer;
